/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderIncompleteDeliveryResolveRequest
 */
export interface OrderIncompleteDeliveryResolveRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderIncompleteDeliveryResolveRequest
     */
    resolutionNote?: string;
}

/**
 * Check if a given object implements the OrderIncompleteDeliveryResolveRequest interface.
 */
// @ts-ignore
export function instanceOfOrderIncompleteDeliveryResolveRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

// @ts-ignore
export function OrderIncompleteDeliveryResolveRequestFromJSON(json: any): OrderIncompleteDeliveryResolveRequest {
    return OrderIncompleteDeliveryResolveRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function OrderIncompleteDeliveryResolveRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderIncompleteDeliveryResolveRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resolutionNote': !exists(json, 'resolution_note') ? undefined : json['resolution_note'],
    };
}

// @ts-ignore
export function OrderIncompleteDeliveryResolveRequestToJSON(value?: OrderIncompleteDeliveryResolveRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resolution_note': value.resolutionNote,
    };
}

